import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTabsModule} from '@angular/material/tabs';
import {PatientDetailComponent} from "./tabs/patient-detail.component";
import {PatientAppointmentsComponent} from "./tabs/patient-appointments.component";

/** The organizations list page */
@Component({
	selector: 'app-patient',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		PatientDetailComponent,
		PatientAppointmentsComponent
	],
	templateUrl: './patient.component.html',
	styleUrl: './patient.component.scss'
})
export class PatientComponent implements OnInit, OnDestroy {

	constructor() {
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}
}
